import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import SidePanel from '../components/SidePanel';
import CreateVehicleModal from '../components/CreateVehicleModal';

const AdminVehiclesPage = () => {
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const fetchVehicles = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/vehicles`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setVehicles(data.vehicles);
      } else {
        const data = await response.json();
        setError(data.message || 'Failed to fetch vehicles');
        if (response.status === 401) {
          navigate('/login');
        }
      }
    } catch (error) {
      setError('Error fetching vehicles');
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, [navigate]);

  const handleCreate = () => {
    setSelectedVehicle(null);
    setIsModalOpen(true);
  };

  const handleEdit = (vehicle) => {
    setSelectedVehicle(vehicle);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/vehicles/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      fetchVehicles();
    } catch (error) {
      setError('Error deleting vehicle');
    }
  };

  const handleSave = async (formData) => {
    const token = localStorage.getItem('token');
    const method = selectedVehicle ? 'PUT' : 'POST';
    const url = selectedVehicle
      ? `${process.env.REACT_APP_BASE_URL_API}/api/vehicles/${selectedVehicle.id}`
      : `${process.env.REACT_APP_BASE_URL_API}/api/vehicles`;

    const body = new FormData();
    body.append('name', formData.name);
    body.append('description', formData.description);
    body.append('number', formData.number);
    if (formData.images) {
      formData.images.forEach(image => {
        body.append('images', image);
      });
    }

    try {
      await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body,
      });
      fetchVehicles();
      setIsModalOpen(false);
    } catch (error) {
      setError('Error saving vehicle');
    }
  };

  return (
    <div className="flex h-screen bg-[#f4f7fa]">
      <SidePanel handleLogout={handleLogout} />
      <div className="flex-1 p-10">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl font-bold text-[#364A9A] font-poppins">Vehicles</h1>
          <button onClick={handleCreate} className="bg-green-500 text-white font-bold py-2 px-4 rounded-lg shadow-lg hover:shadow-xl transition duration-300 ease-in-out transform hover:scale-105 font-poppins">
            Create New
          </button>
        </div>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b">Name</th>
                  <th className="py-2 px-4 border-b">Description</th>
                  <th className="py-2 px-4 border-b">Number</th>
                  <th className="py-2 px-4 border-b">Actions</th>
                </tr>
              </thead>
              <tbody>
                {vehicles.map((vehicle) => (
                  <tr key={vehicle.id}>
                    <td className="py-2 px-4 border-b">{vehicle.name}</td>
                    <td className="py-2 px-4 border-b">{vehicle.description}</td>
                    <td className="py-2 px-4 border-b">{vehicle.number}</td>
                    <td className="py-2 px-4 border-b">
                      <button onClick={() => handleEdit(vehicle)} className="bg-blue-500 text-white font-bold py-1 px-2 rounded-lg mr-2">
                        Edit
                      </button>
                      <button onClick={() => handleDelete(vehicle.id)} className="bg-red-500 text-white font-bold py-1 px-2 rounded-lg">
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <CreateVehicleModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onSave={handleSave} vehicle={selectedVehicle} />
    </div>
  );
};

export default AdminVehiclesPage;